import { useRef } from "react";
import retarget from "../feature/righttime.jpg";
import memory from "../feature/cust-mem.webp";
import naturallanguage from "../feature/naturallanguage.jpg";
import maeven from "../feature/maeven.webp";
import payments from "../feature/pymt.webp";
import pos from "../feature/capture.webp";
import {Link} from 'react-router-dom';
import { ArrowLeft, ArrowRight } from "react-feather";
import Feedback from "./Feedback";
import UseCaseCard from "./UseCaseCard";

import perfume from "../feature/perfume.webp";
import salon from "../feature/salon.webp";
import suppliments from "../feature/suppliments.webp";
import cosmetics from "../feature/cosmetics.webp";
import supermarkets from "../feature/supermarkets.webp";
import mengrooming from "../feature/mengrooming.webp";
import IntegrationSection from "./IntegrationSection";


function Features(){

    const scrollRef = useRef(null);

    const scroll = (direction) => {
      const el = scrollRef.current;
      if (!el) return;

      const scrollAmount = 300; // adjust for feel

      el.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    };
    const categories = [
      {
        name: "Perfume Retailers",
        description: "Bring customers back when their scent runs out.",
        cat_image: perfume,
        tag: "Top Pick",
      },
      {
        name: "Beauty and Cosmetics",
        description: "Keep customers restocking — automatically.",
        cat_image: cosmetics,
        tag: "Popular",
      },
      {
        name: "Supplements",
        description: "Ensure customers never run out of essentials.",
        cat_image: suppliments,
      },
      {
        name: "Beard & Men’s Grooming",
        description: "Bring customers back when it’s time to restock their grooming essentials.",
        cat_image: mengrooming,
      },
      {
        name: "Supermarkets",
        description: "Bring customers back for their weekly essentials — automatically.",
        cat_image: supermarkets,
      },
      {
        name: "Salons & Barbershops",
        description: "Fill your schedule with returning clients.",
        cat_image: salon,
      },
    ];
    
    return (
      <>      
        <IntegrationSection/>
        <div className="col-12 mt-5 pt-6indx0 mb-5" >
              <div className="container">

                {/* HEADER */}
                <h1 className="mb-5 mw700 fw800">
                  <b>
                    Everything you need to{" "}
                    <span className="bg-gold-yellow">bring customers back</span>
                  </b>
                </h1>

                <div className="row">

                  {/* SALES & CUSTOMER CAPTURE */}
                  <div className="col-lg-4" id="pos">
                    <div className="card p-4 bordered-4">
                      <img src={pos} alt="" className="mb-4"/>

                      <h4 className="fw800"><b>Sales & Customer Capture</b></h4>
                      <p>
                        Capture every sale and automatically build a detailed customer history, so you can understand buying habits and bring customers back at the right time.
                      </p>
                      <Link to="/sales-customer-capture" className="text-primary font-bold">Learn more <ArrowRight/></Link>
                    </div>
                  </div>


                  {/* CUSTOMER INTELLIGENCE */}
                  <div className="col-lg-4" id="customer-memory">
                    <div className="card p-4 bordered-4">
                      <img src={memory} alt="" className="mb-4"/>

                      <h4 className="fw800"><b>Customer Intelligence</b></h4>
                      <p>
                        See which customers return, who is likely to churn, and which products drive repeat purchases so you can make smarter business decisions.
                      </p>
                      <Link to="/customer-memory" className="text-primary font-bold">Learn more <ArrowRight/></Link>
                    </div>
                  </div>

                  

                  {/* PAYMENTS */}
                  <div className="col-lg-4" id="payments">
                    <div className="card p-4 bordered-4">
                      <img src={payments} alt="" className="mb-4"/>

                      <h4 className="fw800"><b>Connected Payments</b></h4>
                      <p>
                        Accept payments across mobile money, cards, and bank transfers while automatically linking each transaction to a customer profile for better tracking.
                      </p>
                      <Link to="/payments" className="text-primary font-bold">Learn more <ArrowRight/></Link>
                    </div>
                  </div>

                  {/* MESSAGING */}
                  <div className="col-lg-4" id="messaging">
                    <div className="card p-4 bordered-4">
                      <img src={naturallanguage} alt="" className="mb-4"/>

                      <h4 className="mt-4 fw800"><b>Natural Messaging at Scale</b></h4>
                      <p>
                        Send natural, human-like messages that keep customers engaged between purchases, helping you stay top of mind without sounding automated or spammy.
                      </p>
                      <Link to="/repeat-revenue-agent" className="text-primary font-bold">Learn more <ArrowRight/></Link>
                    </div>
                  </div>



                  {/* MAEVEN */}
                  <div className="col-lg-4" id="maeven">
                    <div className="card p-4 bordered-4">
                      <img src={maeven} alt="" className="mb-4"/>

                      <h4 className="mt-4 fw800"><b>Mæven AI Assistant</b></h4>
                      <p>
                        Ask Kadhr anything about your business, get instant insights, and take action immediately—from identifying top customers to sending messages that drive revenue.
                      </p>
                      <Link to="/maeven" className="text-primary font-bold">Learn more <ArrowRight/></Link>
                    </div>
                  </div>


                  {/* REORDER AGENT */}
                  <div className="col-lg-4" id="reorder-agent">
                    <div className="card p-4 bordered-4">
                      <img src={retarget} alt="" className="mb-4 br-18"/>

                      <h4 className="mt-3 fw800"><b>Repeat Revenue Agent</b></h4>
                      <p>
                        Kadhr detects when customers are ready to buy again using real purchase data and prepares messages you can send instantly to drive repeat sales.
                      </p>
                      <Link to="/repeat-revenue-agent" className="text-primary font-bold">Learn more <ArrowRight/></Link>
                    </div>
                  </div>

                </div>


                {/* CTA */}
                <div className="text-center mt-5">
                  <Link className="main-btn btn-hover bg-dark text-white" to="/seller/register">
                    Start bringing customers back
                  </Link>
                </div>

              </div>
        </div>
        <div
          className="col-12 text-center mt-5 mb-5 pt-5 pb-5 fade-section"
          id="usecases"
          style={{ background: "linear-gradient(135deg, rgb(255, 247, 213), rgb(131, 182, 245))" }}
        >
          <div className="container mt-6 mb-5">
            <div className="d-flex justify-content-between align-items-center mb-4">

              <h1 className="text-left mw700 mb-0 mpl-2 fw800">
                <b>
                  Built for businesses{" "}
                  <span className="bg-gold-yellow">with repeat customers</span>
                </b>
              </h1>

              {/* 🔹 SCROLL ARROWS */}
              <div className="d-flex gap-2">
                <button className="scroll-btn" onClick={() => scroll('left')}>
                  <ArrowLeft size={18} className="mb-2"/>
                </button>
                <button className="scroll-btn" onClick={() => scroll('right')}>
                  <ArrowRight size={18} className="mb-2"/>
                </button>
              </div>

            </div>

            <div ref={scrollRef} className="row flex-nowrap overflow-auto p-3 usecase-scroll">
             {categories.map((category, index) => (
                  <div key={index} className="col-10 col-md-6 col-lg-4 flex-shrink-0 pe-3">
                  
                  <UseCaseCard
                    title={category.name}
                    description={category.description}
                    image={category.cat_image}
                    tag={category.tag}
                  />

                </div>
              ))}
            </div>
            
          </div>
        </div> 
        
        <Feedback/>
      </>
    )
}

export default Features;
